import React, { useEffect } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import CertItem from './CertItem'
import { Dialog } from 'antd-mobile-v5'
import { useHasLogin } from '../../services/hooks'
import { getCookie, setCookie } from '../common/cookie'
import ClubMembershipPopup from '../../components/EcardsList/ClubMembershipPopup'

import styles from './CertList.module.css'

const CertsList = ({ ecards, userInfo, visitStatus }) => {
  const { formatMessage } = useIntl()
  const { run, data } = useHasLogin({
    manual: true,
    onSuccess: (data) => {
      if (data.wenJuan && data.wenJuan.type && !getCookie(data.wenJuan.type)) {
        setCookie(data.wenJuan.type, true)
        Dialog.show({
          title: formatMessage({ id: 'questionaire-title' }),
          content: formatMessage(
            { id: 'questionaire-message' },
            { course: formatMessage({ id: `questionaire-course-${data.wenJuan.type}` }) }
          ),
          showCloseButton: true,
          closeOnAction: true,
          actions: [
            [
              {
                key: 'cancel',
                text: formatMessage({ id: 'common-cancel' }),
              },
              {
                key: 'open',
                bold: true,
                text: formatMessage({ id: 'common-confirm' }),
                primary: true,
                onClick: () => {
                  window.location.href = data.wenJuan.url
                },
              },
            ],
          ],
        })
      }
    },
  })

  useEffect(() => {
    run()
  }, [])
  return (
    <div className={styles['list-wrapper']}>
      {data && <ClubMembershipPopup displayStatus={data.clubPopup} />}
      {ecards?.length > 0 ? (
        ecards.map((ecard) => (
          <CertItem key={ecard.uniqueId} ecard={ecard} userInfo={userInfo} visitStatus={visitStatus} />
        ))
      ) : (
        <div className={styles['no-certs']}>
          <FormattedMessage id="certlist-noCert" />
        </div>
      )}
    </div>
  )
}

export { CertsList }
